/** @format */
import angular from 'angular';
import _ from 'lodash';

export const CommonBulkEditServiceModule = 'sis-components.bulkedit.bulkEditService';

(function () {
    bulkEditStore.$inject = ['$log', 'SESSION_STORAGE_KEY_PREFIX'];
    bulkEditService.$inject = ['$state', 'bulkEditStore', 'alertsService'];
    angular
        .module(CommonBulkEditServiceModule, ['ui.router', 'ui.router.upgrade', 'sis-components.alertsService'])
        .service('bulkEditService', bulkEditService)
        .factory('bulkEditStore', bulkEditStore)
        .constant('BULK_EDIT_STEP', {
            1: {
                title: 'BULK_EDIT.STEP1.TITLE',
                complete: false,
                current: false,
                index: 0,
            },
            2: {
                title: 'BULK_EDIT.STEP2.TITLE',
                complete: false,
                current: false,
                index: 1,
            },
            3: {
                title: 'BULK_EDIT.STEP3.TITLE',
                complete: false,
                current: false,
                index: 2,
            },
            4: {
                title: 'BULK_EDIT.STEP4.TITLE',
                complete: false,
                current: false,
                index: 3,
            },
        })
        .constant('SESSION_STORAGE_KEY_PREFIX', 'BULK_EDIT_OBJECTS__');

    function bulkEditService($state, bulkEditStore, alertsService) {
        const api = {
            returnRoute: '.',
            returnRole: '',
            processInfo: undefined,
            closeBulkEdit() {
                bulkEditStore.clear();
                $state.go(api.returnRoute, { role: api.returnRole }, { reload: true, inherit: false, notify: true });
            },
            openBulkEdit(returnRoute, bulkEditRoute, bulkEditRouteParams, returnRole) {
                alertsService.dismissAllAlerts();
                api.returnRoute = returnRoute;
                api.returnRole = returnRole || '';
                $state.go(bulkEditRoute, bulkEditRouteParams, { reload: true, inherit: false, notify: true });
            },
        };

        return api;
    }

    function bulkEditStore($log, SESSION_STORAGE_KEY_PREFIX) {
        return {
            clear() {
                for (let i = 0; i < sessionStorage.length; i++) {
                    const key = sessionStorage.key(i);
                    if (_.startsWith(key, SESSION_STORAGE_KEY_PREFIX)) {
                        sessionStorage.removeItem(key);
                        i -= 1;
                    }
                }
            },
            save(cacheKey, data) {
                sessionStorage.setItem(SESSION_STORAGE_KEY_PREFIX + cacheKey, angular.toJson(data));
            },
            get(cacheKey) {
                try {
                    const json = sessionStorage.getItem(SESSION_STORAGE_KEY_PREFIX + cacheKey);
                    return json ? angular.fromJson(json) : undefined;
                } catch (err) {
                    $log.warn('Failed to load cached data from sessionStorage', err);
                    return undefined;
                }
            },
        };
    }
})();
